<!-- header -->
<!-- <div class="header-wrapper" [ngClass]="{'mbm-header': params?.utm_campaign?.includes('mbm')}">
  <app-referral-header [params]="params"></app-referral-header>
</div> -->

<!-- Truecaller button -->
<app-truecaller-popup *ngIf="!userdata && isMobile && !vwo.dm_banner_AB() && !isIos" [execute]="eventsSubject.asObservable()"></app-truecaller-popup>
<div class="banner-wrapper" *ngIf="vwo.dm_banner_AB()" [ngClass]="{'banner-wrapper-1': vwo.dm_banner_AB()}" inViewport (inViewportAction)="toggleDonationDock($event)" id="form-donate">
  <app-banner (viewportEmit)="fixedPostion($event)"></app-banner>
</div>

<div *ngIf="userdata?.aggdonationall?.funds >= 1 && !nudge && params?.utm_source?.match('external_ct|external_clevertap')" class="welcome-nudge">
  <app-module-loader moduleId="welcome-back-nudge" selector="app-welcome-back-nudge" [load]="true"></app-module-loader>
</div>

<div *ngIf="!vwo.dm_banner_AB()" class="banner-wrapper" [ngClass]="{'banner-wrapper-2': (globalVar?.dm_slabs_AB && !params?.utm_source?.includes('f2f') || ((vwo.multi_cause_dm_AB() || multicauseParamDMTrue) && params?.page?.includes('op'))), 'banner-wrapper-3': (vwo.dm_lives_AB() && (!userdata || params?.page?.includes('op'))), 'banner-wrapper-4': (vwo.dm_lives_AB() || vwo.life_slab_AB()) && activatedOffer, 'banner-wrapper-5': vwo.life_slab_AB() && userdata, 'banner-wrapper-6': vwo.life_slab_AB() && !userdata && !params?.page?.includes('op'), 'banner-wrapper-7': vwo.life_slab_AB() && activatedOffer, 'banner-wrapper-8': vwo.life_slab_AB() && activatedOffer && params?.page?.includes('op'), 'banner-wrapper-9': vwo.life_slab_AB() && userdata && params?.page?.includes('op') && !activatedOffer, 'banner-wrapper-10': (vwo.multi_cause_dm_AB() || multicauseParamDMTrue) && params?.page?.includes('op')}" inViewport (inViewportAction)="toggleDonationDock($event)" (click)="showTruecallerPopup || !(vwo.multi_cause_dm_AB() || multicauseParamDMTrue) ? bannerClickList() : ''" id="form-donate">
  <div class="d-banner d-none d-lg-block d-md-block" [ngClass]="{'d-banner-1': params?.page?.includes('op')}">
    <img *ngIf="!params?.utm_campaign?.includes('mbm')" loading="lazy" data-src="/assets/images/sip/sip-bg.png" [ngClass]="{'d-banner-img': ((vwo.dm_lives_AB() || vwo.life_slab_AB()) && (params?.page?.includes('op') || !userdata))}" />
    <img class="mbm-bg" *ngIf="params?.utm_campaign?.includes('mbm')" loading="lazy" data-src="/assets/images/sip/background/mbm.png" />
  </div>
  <div class="m-banner d-block d-lg-none d-md-none">
    <img *ngIf="!params?.utm_campaign?.includes('mbm')" loading="lazy" data-src="/assets/images/sip/sip-bg-mobile.png" />
    <img *ngIf="params?.utm_campaign?.includes('mbm')" loading="lazy" data-src="/assets/images/sip/background/mbm-small.png" />
  </div>

  <div *ngIf="(!globalVar?.dm_slabs_AB || params?.utm_source?.includes('f2f')) && !vwo.dm_lives_AB() && !vwo.life_slab_AB() && loadAfterVwo && ((!vwo.multi_cause_dm_AB() && !multicauseParamDMTrue) || params?.utm_source?.includes('f2f'))" inViewport (inViewportAction)="fixedPostion($event)" id="donation-form" class="payment-card" [ngClass]="{'mbm': params?.utm_campaign?.includes('mbm')}">

    <app-offer-tag *ngIf="activatedOffer || params['rewards'] === '1'" class="d-lg-none d-md-none"></app-offer-tag>

    <div class="header">
      <div class="title">Social Impact Plan</div>
      <!-- <ul class="dots"><li *ngFor="let i of [1,2,3,4,5,6,7,8,9]"></li></ul> -->
      <div *ngIf="params?.page!=='op'" class="sub-title">
        <div *ngIf="!activatedOffer && text">Join our community of monthly donors providing urgent medical care to children</div>
        <div *ngIf="activatedOffer || offerpriority"><strong>Join now</strong> and <app-currency-icon [currency]="'INR'"></app-currency-icon> {{activatedOffer}} will be added to your SIP subscription.</div>
        <div *ngIf="params['rewards'] === '1' && !offerpriority"><strong>Join now</strong> and and claim exciting rewards and benefits!</div>
      </div>
    </div>

    <div class="shadow-card">
      <app-payment-sip [config]="{
        themeColor: '#029CBE',
        slabTheme: 'slab-theme-v2',
        slabsPostLabel: '/mo',
        formTheme: 'form-theme-v2',
        dialogBtnTheme: 'payment-btn-v1',
        origin: 'rfd',
        showTutorial: false,
        showOptionBackBtn: true,
        disableCard: true
      }">
      </app-payment-sip>

    </div>
  </div>
  <div *ngIf="(!globalVar?.dm_slabs_AB || params?.utm_source?.includes('f2f')) && !vwo.dm_lives_AB() && !vwo.life_slab_AB() && loadAfterVwo && ((vwo.multi_cause_dm_AB() || multicauseParamDMTrue) && !params?.utm_source?.includes('f2f') && !(userdata?.listsubscriptions?.medical && userdata?.listsubscriptions?.animals && userdata?.listsubscriptions?.education))" inViewport (inViewportAction)="fixedPostion($event)" id="donation-form" class="payment-card" [ngClass]="{'mbm': params?.utm_campaign?.includes('mbm'), 'multicause': vwo.multi_cause_dm_AB() || multicauseParamDMTrue}">
    <app-module-loader moduleId="multi-cause-dm" selector="app-multi-cause-dm" [load]="true" [outputs]="{showTruecaller: showTruecaller}"></app-module-loader>
  </div>

  <div id="donation-form" class="payment-card-v1" *ngIf="globalVar?.dm_slabs_AB && !params?.utm_source?.includes('f2f') && !vwo.dm_lives_AB() && !vwo.life_slab_AB()" inViewport (inViewportAction)="fixedPostion($event)">
    <div *ngIf="activatedOffer" class="offer-applied"><span [innerHtml]="util.getCurrencyIcon('INR')?.symbol"></span> {{activatedOffer}} OFFER APPLIED!</div>
    <div class="header">
      <div class="left">
        <div class="title">Social Impact Plan</div>
          <div class="text">Join our community of monthly donors providing urgent medical care to children</div>
      </div>
      <div class="right">
        <img src="/assets/images/sip-by-ketto.png" alt="sip-by-ketto" />
      </div>
    </div>

    <div class="payment-form">
      <app-payment-sip [config]="{
       themeColor: '#01BFBD',
       slabTheme: 'slab-theme-v2',
       slabsPostLabel: '',
       formTheme: 'form-theme-v4',
       dialogBtnTheme: 'payment-btn-v1',
       donateBtnLabel: 'Join Monthly Giving',
       origin: 'rfd',
       showTutorial: false,
       showOptionBackBtn: true,
       disableCard: true
      }"></app-payment-sip>

    </div>
  </div>

  <div *ngIf="vwo.dm_lives_AB() || vwo.life_slab_AB()" class="lives-select" inViewport (inViewportAction)="fixedPostion($event)" id="donation-form">
    <app-dm-select-lives [config]="{activatedOffer: activatedOffer}"></app-dm-select-lives>
  </div>
</div>

<div class="separator-1" *ngIf="(globalVar?.dm_slabs_AB && !params?.utm_source?.includes('f2f')) || vwo.dm_lives_AB() || vwo.life_slab_AB() || vwo.multi_cause_dm_AB() || multicauseParamDMTrue"></div>

<!--Monthly text-->
<div class="referral-bg-image join-sip referral-bg-image-3" id="about-sip" [ngClass]="{'referral-bg-image-1': vwo.dm_banner_AB(), 'referral-bg-image-2': (globalVar?.dm_slabs_AB && !params?.utm_source?.includes('f2f')) || vwo.dm_lives_AB() || vwo.life_slab_AB() || vwo.multi_cause_dm_AB() || multicauseParamDMTrue}">
  <div class="container">
    <div class="what-is-monthly">
      <div class="heading">
        Why Join
        <span>
          Social Impact Plan?
        </span>
      </div>
      <hr class="hr-yellow my-3">
      <div class="sub-heading">
        Every 2 minutes, a child dies because they can't afford medical aid. With
        <span class="sip-color">
          <strong>
            Social Impact Plan
          </strong>
        </span>, we are on a mission to make healthcare a reality for everyone, no matter who you are.
      </div>
      <div class="video">
        <app-module-loader moduleId="video-dm" selector="app-video-dm" [load]="true"></app-module-loader>
      </div>
      <div class="wrapper">
        <app-monthly-static-sprite [params]="params"></app-monthly-static-sprite>
      </div>
    </div>
  </div>
</div>

<div class="rewards">
  <app-rewards-and-benefits (text)="textshown($event)"></app-rewards-and-benefits>
</div>

<!-- how it works section -->
<div class="how-it-works" id="how-it-works-sip">
  <app-referral-how-it-works></app-referral-how-it-works>
</div>


<!-- our impact -->
<div class="our-impact" id="our-impact-sip">
  <app-sip-impact></app-sip-impact>
</div>

<!--success stories-->
<div class="success-stories">
  <app-referral-success-stories></app-referral-success-stories>
</div>

<!--Get a life-->
<div class="get-life text-center d-none d-lg-block d-md-block">
  Your gift can make sure that every medical campaign is a success story!
  <button mat-raised-button (click)="util.scrollIntoViewSmoothly('form-donate'); eventTrack()">Donate Monthly</button>
</div>

<!-- who are we -->
<div class="who-are-we" id="who-we-are-sip">
  <app-static-who-are-we></app-static-who-are-we>
</div>


<!--social srtip-->
<div class="social-strip container eminent">
  <div class="title">Eminent Donors on Ketto</div>
  <hr class="hr-yellow mt-3 mb-5">
    <app-social-strip></app-social-strip>
</div>


<!--featured in section-->
<div class="featured-wrapper">
  <div class="container">
    <div class="title text-center">Featured In</div>
    <hr class="hr-yellow mt-3 mb-4">
    <div class="featured-hr d-none d-lg-block d-md-block"></div>
    <img loading="lazy" data-src="/assets/images/sip/icons/Logos.png" class="d-none d-lg-block d-md-block" width="100%"/>
    <div class="d-block d-lg-none d-md-none">
      <ngx-glide [perView]="2.2" [showArrows]="false" [showBullets]="false" [gap]="2">
        <div class="feature-slide"  *ngFor="let item of [1,2,3,4,5,6,7]; index as i">
          <img loading="lazy" [attr.data-src]="'/assets/images/sip/logos/logo-' + (i+1) +'.png'" width="auto"/>
        </div>
      </ngx-glide>
    </div>
    <div class="featured-hr d-none d-lg-block d-md-block"></div>
  </div>
</div>

<!--faqs-->
<div class="faqs portfolio" id="faqs-sip">
  <div class="title">FAQs</div>
  <div class="separator"></div>
    <app-faqs page="portfolio"></app-faqs>
</div>

<div class="talk-to-us" *ngIf="vwo.talk_to_us_AB()">
  <app-talk-to-us-btn [config]="{type:'v1', lead_type: 'user-request-lead'}"></app-talk-to-us-btn>
</div>


<!--chat with us module-->
<div class="chat-with-us d-none d-lg-block d-md-block">
  <app-chat-with-us [html]="'Some fundraisers are not eligible for tax deduction such as 80G, 501(c), etc. Any Questions? '"></app-chat-with-us>
</div>


<div *ngIf="isMobile && !hideDonateDocker" #donationDock class="donation-dock inactive">
  <button class="donation-btn" mat-button (click)="util.scrollIntoViewSmoothly('form-donate')">
    Start Monthly Giving
  </button>
</div>

<div class="footer-wrapper d-block d-lg-none d-md-none">
  <app-portfolio-mobile-footer></app-portfolio-mobile-footer>
</div>

<!-- Impact Docker -->
<app-impact-docker *ngIf="!inviewPort.donationForm && inviewPort.isDonationFormShowed" [icon]='false' elementId="form-donate" btnLabel="Donate Monthly" text="Join our community of monthly donors providing urgent medical care."></app-impact-docker>

<!-- Offer Popup -->
<app-offer *ngIf="userdata && !userdata?.listsubscriptions?.medical && currency==='INR'" [config]="{theme: globalVar?.dm_slabs_AB && globalVar?.dm_slabs_AB && !params?.utm_source?.includes('f2f') ? '1': ''}"></app-offer>


<!-- Sip Tickr -->
<app-sip-ticker  *ngIf="!isMobile && !userdata?.listsubscriptions?.medical"></app-sip-ticker>
